import { useState, useEffect, useRef, forwardRef } from 'react'
import {
  Form,
  Input,
  ModalProps,
  FormProps,
  Modal,
  Space,
  Divider,
  Descriptions,
  DateField,
  Button,
  Select,
  Tag,
  Icons,
  Table,
  Row,
  Typography,
  Col,
} from '@pankod/refine-antd'
import { DatePicker, TimePicker, List } from 'antd'
import { useGetIdentity, useSelect, useOne } from '@pankod/refine-core'
import type { Moment } from 'moment'
import dayjs from 'dayjs'
import moment from 'moment'
import { IPaper, ITestEvent, ITestEventAssignedPapers, ITestTrack } from 'interfaces'
import TestEventSlotsShow from 'components/test_event_slots'
import metaData from 'metadata/test_events'

type EditTestEventProps = {
  modalProps: ModalProps
  formProps: FormProps
  close?: () => void
}

var isSameOrBefore = require('dayjs/plugin/isSameOrBefore')
dayjs.extend(isSameOrBefore)

const { Text, Title } = Typography

export const EditTestEvent: React.FC<EditTestEventProps> = ({ modalProps, formProps, close }) => {
  const testEventAssignedPapers: ITestEventAssignedPapers[] = formProps?.initialValues?.assigned_papers

  const testEventPapers: IPaper[] = formProps?.initialValues?.papers

  const { options: testTrackQueryOptions } = useSelect<ITestTrack>({
    resource: 'test_tracks',
    optionLabel: 'name',
    optionValue: 'id',
    filters: [
      { field: 'id', operator: 'in', value: formProps?.initialValues?.product?.test_track_ids },
      { field: 'in_use', operator: 'eq', value: true },
    ],
    metaData: { fields: ['id', 'name'] },
    queryOptions: { enabled: !!modalProps?.visible },
  })

  const { data: user } = useGetIdentity()
  const [numOfSlots, setNumOfSlots] = useState<any[] | undefined>([]) // initial slot data
  const [slots, setSlots] = useState<{ test_track_id: string; list_of_slots: [{ date: string; start_time: string; end_time: string }] }[]>([])
  const [selectedSlot, setSelectedSlot] = useState<{ date: string; start_time: string; end_time: string }>()

  //new slot format
  const [multipleTimeSlots, setMultipleTimeSlots] = useState<any>([])
  const [selectedTestTrack, setSelectedTestTrack] = useState<string>('')
  const [timeSlot, setTimeSlot] = useState<any[]>([]) // for display in table
  const [existingDate, setExistingDate] = useState<string>('')
  const [newDate, setNewDate] = useState<string | undefined>('')
  const [dateVal, setDateVal] = useState<Moment | undefined | null>()
  const [editMode, setEditMode] = useState<boolean>(false)

  //To prevent user from duplicating new date with existing date
  const [listOfExistingDates, setListOfExistingDates] = useState<string[]>()
  const [dateExists, setDateExists] = useState<boolean>()

  //form finish
  const onFinish = (values: any) => {
    return formProps.onFinish && formProps.onFinish({ ...values, slots })
  }

  const onClickAddSlot = () => {
    const newSlotData = slots?.map(slot => {
      const newListOfSlots = slot?.list_of_slots
      if (slot?.test_track_id === selectedTestTrack) {
        const date = dateVal?.toISOString()
        const startTime = dayjs(timeSlot?.[0]).toISOString()
        const endTime = dayjs(timeSlot?.[1]).toISOString()
        date && startTime && endTime && newListOfSlots.push({ date, start_time: startTime, end_time: endTime })
      }
      return { test_track_id: slot?.test_track_id, list_of_slots: newListOfSlots }
    })
    setSlots(newSlotData)
    setDateVal(null)
    setTimeSlot([])
  }

  const onClickRemoveSlot = (mode?: string) => {
    const newSlots = slots?.map(slotData => {
      const newSlotList = slotData?.list_of_slots
      if (slotData?.test_track_id === selectedTestTrack) {
        slotData?.list_of_slots?.forEach((dateTime, idx) => {
          const date = dayjs(dateTime?.date).isSame(dayjs(selectedSlot?.date), 'day')
          const startTime = dayjs(dateTime?.start_time).isSame(dayjs(selectedSlot?.start_time), 'minutes')
          const endTime = dayjs(dateTime?.end_time).isSame(dayjs(selectedSlot?.end_time), 'minutes')
          if (date && startTime && endTime) {
            if (mode === 'edit') {
              const date = dateVal?.toISOString()
              const startTime = dayjs(timeSlot?.[0]).toISOString()
              const endTime = dayjs(timeSlot?.[1]).toISOString()
              date && startTime && endTime && newSlotList?.splice(idx, 1, { date, start_time: startTime, end_time: endTime })
              setEditMode(false)
            } else {
              newSlotList?.splice(idx, 1)
            }
          }
        })
      }
      return { test_track_id: slotData?.test_track_id, list_of_slots: newSlotList }
    })
    setSlots(newSlots)
    setSelectedSlot(undefined)
    setDateVal(null)
    setTimeSlot([])
  }

  const onslotchange = (slot: string) => {
    const data = JSON.parse(slot)
    setSelectedSlot(data)
  }

  //for editable table data
  // const renderDateTime = (record: any, dates: string[]) => {
  //   const timeSlotArr = dates?.map(date => {
  //     const timeSlots = record.slots[date]
  //     const displaySlots = (
  //       <>
  //         {timeSlots.map((eachSlot: string[], idx: any) => (
  //           <Tag key={idx}>
  //             <Space>
  //               <DateField value={eachSlot[0]} format="LT" />
  //               <span>to</span>
  //               <DateField value={eachSlot[1]} format="LT" />

  //               <Icons.CloseOutlined
  //                 style={{ cursor: 'pointer' }}
  //                 value={idx}
  //                 onClick={() => {
  //                   setNumOfSlots((prevData: any) => {
  //                     const newData = prevData.map((data: { id: string; slots: any }) => {
  //                       if (data.id === record.id) {
  //                         data.slots[date].splice(idx, 1)
  //                       }
  //                       return data
  //                     })
  //                     return newData
  //                   })
  //                 }}
  //               />
  //             </Space>
  //           </Tag>
  //         ))}
  //       </>
  //     )
  //     return (
  //       <List header="" style={{ marginBottom: 10 }}>
  //         {/* gtid */}
  //         <Row>
  //           <Col span={6}>
  //             <DateField value={date} format="LL" />
  //             <Icons.CloseOutlined
  //               style={{ cursor: 'pointer' }}
  //               value={date}
  //               onClick={value => {
  //                 setNumOfSlots((prevData: any) => {
  //                   const newData = prevData.map((data: { id: string; slots: any }) => {
  //                     if (data.id === record.id) {
  //                       delete data.slots[date]
  //                     }
  //                     return data
  //                   })
  //                   return newData
  //                 })
  //               }}
  //             />
  //           </Col>
  //           <Col span={18}>{displaySlots}</Col>
  //         </Row>
  //       </List>
  //     )
  //   })

  //   return timeSlotArr
  // }

  useEffect(() => {
    if (formProps?.initialValues?.slots !== undefined) {
      setSlots(formProps?.initialValues?.slots)
      setNumOfSlots(formProps.initialValues.slots)
    }
  }, [formProps?.initialValues?.slots, modalProps?.visible])

  // useEffect(() => {
  //   {
  //     numOfSlots &&
  //       numOfSlots?.map(eachSlot => {
  //         if (eachSlot.id === selectedTestTrack) {
  //           const dateList = Object.keys(eachSlot.slots)
  //           setListOfExistingDates(dateList)
  //         }
  //       })
  //   }
  // }, [numOfSlots, selectedTestTrack, modalProps?.visible])

  return (
    <Modal
      {...modalProps}
      title="Edit Test Event"
      afterClose={() => {
        // setMultipleTimeSlots([])
        setSelectedSlot(undefined)
        setSelectedTestTrack('')
        setNumOfSlots([])
        setDateVal(undefined)
        setNewDate('')
        setExistingDate('')
        setEditMode(false)
      }}
    >
      <Form {...formProps} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Test Event Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Descriptions style={{ paddingTop: '5' }}>
          <Descriptions.Item label="location">{formProps.initialValues?.location}</Descriptions.Item>
          <Descriptions.Item label="Mode of Exam">{formProps.initialValues?.mode_of_exam}</Descriptions.Item>
        </Descriptions>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
        <Title level={5}>Edit Slots</Title>
        <TestEventSlotsShow listOfSlots={slots} style={{ minWidth: '300px', marginTop: 5, marginBottom: 10 }} />
        <Col>
          <Form.Item name="slots">
            <Select
              style={{ width: '40%', display: 'block', marginBottom: '5px' }}
              onChange={value => {
                setSelectedTestTrack(value)
              }}
              placeholder="Select Test Track"
            >
              {testTrackQueryOptions.map(testTrack => (
                <option key={testTrack.value} value={testTrack.value}>
                  {testTrack.label}
                </option>
              ))}
            </Select>

            <Select
              value={JSON.stringify(selectedSlot)}
              style={{ width: '40%' }}
              placeholder="Select Existing Slots"
              onChange={(value, option) => {
                console.log('option and value', option, value)
                onslotchange(value)
              }}
            >
              {slots?.map(slotData => {
                if (slotData?.test_track_id === selectedTestTrack) {
                  return slotData?.list_of_slots?.map(eachSlot => {
                    let disable = false
                    testEventAssignedPapers?.forEach(assignedPaper => {
                      if (assignedPaper?.test_track_id === selectedTestTrack) {
                        const { date, start_time, end_time } = assignedPaper?.slot_assigned
                        const sameDate = dayjs(date).isSame(dayjs(eachSlot?.date), 'day')
                        const sameStartTime = dayjs(start_time).isSame(dayjs(eachSlot?.start_time), 'minutes')
                        const sameEndTime = dayjs(end_time).isSame(dayjs(eachSlot?.end_time), 'minutes')
                        if (sameDate && sameStartTime && sameEndTime) disable = true
                      }
                    })
                    !disable &&
                      testEventPapers?.forEach(paper => {
                        if (paper?.test_track_id === selectedTestTrack) {
                          const paperSlot = JSON.parse(paper?.slot_data)
                          const { date, start_time, end_time } = paperSlot
                          const sameDate = dayjs(date).isSame(dayjs(eachSlot?.date), 'day')
                          const sameStartTime = dayjs(start_time).isSame(dayjs(eachSlot?.start_time), 'minutes')
                          const sameEndTime = dayjs(end_time).isSame(dayjs(eachSlot?.end_time), 'minutes')
                          if (sameDate && sameStartTime && sameEndTime) disable = true
                        }
                      })
                    return (
                      <option key={eachSlot?.date} value={JSON.stringify(eachSlot)} disabled={disable}>
                        <Space>
                          <Tag>
                            <DateField value={eachSlot?.date} format="LL" disabled={disable} />
                          </Tag>
                          <Tag>
                            <Space>
                              <DateField format="LT" value={eachSlot?.start_time} disabled={disable} />
                              <Text disabled={disable}>To</Text>
                              <DateField format="LT" value={eachSlot?.end_time} disabled={disable} />
                            </Space>
                          </Tag>
                        </Space>
                      </option>
                    )
                  })
                }
              })}
            </Select>
            <Space style={{ flexWrap: 'wrap', marginLeft: '10px', marginBottom: '10px' }}>
              {!editMode && (
                <Button
                  disabled={!!!selectedSlot?.date?.length}
                  size="small"
                  type="primary"
                  name="editSlot"
                  onClick={() => {
                    setDateVal(moment(selectedSlot?.date))
                    setTimeSlot([moment(selectedSlot?.start_time), moment(selectedSlot?.end_time)])
                    setEditMode(true)
                  }}
                >
                  Edit
                </Button>
              )}
              {!editMode && (
                <Button
                  disabled={!!!selectedSlot?.date}
                  size="small"
                  type="primary"
                  name="removeSlot"
                  onClick={e => {
                    onClickRemoveSlot()
                  }}
                >
                  Remove
                </Button>
              )}
              {editMode && (
                <Button
                  size="small"
                  type="primary"
                  danger
                  icon={<Icons.CloseCircleOutlined />}
                  onClick={() => {
                    setEditMode(false)
                    setDateVal(null)
                    setTimeSlot([])
                  }}
                >
                  Cancel Edit
                </Button>
              )}
            </Space>
            <Row> {editMode ? <Text strong>Select New Values</Text> : <Text strong>OR</Text>}</Row>
            <Row>
              <Space>
                <DatePicker
                  disabled={!!!selectedTestTrack}
                  value={dateVal}
                  allowClear
                  placeholder="Select New Date"
                  disabledDate={(current: Moment): boolean => {
                    const isNotValid = current < dayjs()
                    return !!isNotValid
                  }}
                  onChange={date => {
                    setDateVal(date)
                  }}
                  onPanelChange={() => setNewDate('')}
                />
                <TimePicker.RangePicker
                  disabled={!!!selectedTestTrack}
                  value={[timeSlot[0], timeSlot[1]]}
                  onChange={value => {
                    value && setTimeSlot([value[0], value[1]])
                  }}
                />
                <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    if (editMode) {
                      onClickRemoveSlot('edit')
                    } else {
                      onClickAddSlot()
                    }
                  }}
                >
                  {editMode ? <span>Confirm</span> : <span>Add Slot</span>}
                </Button>
              </Space>
            </Row>
            {/* <br />
          <Space>
            <Select
              disabled={!!selectedTestTrack ? !!newDate : true}
              placeholder="Select Existing Date"
              allowClear
              onChange={value => {
                setExistingDate(value)
              }}
            >
              {numOfSlots &&
                numOfSlots?.map(eachSlot => {
                  let returnList: any[] = []

                  if (eachSlot.id === selectedTestTrack) {
                    const dateList = Object.keys(eachSlot.slots)
                    returnList = dateList.map(date => {
                      const shouldHide = dayjs().isAfter(dayjs(date), 'day')

                      return (
                        <option key={date} value={date} disabled={shouldHide}>
                          {<DateField value={date} format="LL" disabled={shouldHide} />}
                        </option>
                      )
                    })
                  }
                  return returnList
                })}
            </Select>

            <DatePicker
              value={dateVal}
              allowClear
              disabled={!!selectedTestTrack ? !!existingDate : true}
              placeholder="Select New Date"
              disabledDate={(current: Moment): boolean => {
                const isNotValid = current < dayjs()
                return !!isNotValid
              }}
              onChange={date => {
                setDateVal(date)
                setDateExists(false)
                listOfExistingDates?.map(existingDate => {
                  if (date?.format('YYYY-MM-DD') === dayjs(existingDate).format('YYYY-MM-DD')) {
                    setDateExists(true)
                    Modal.error({
                      title: 'Date already Exists!',
                      content: `Please select "${dayjs(existingDate).format('LL')}" from existing date dropdown.`,
                    })
                  }
                })
                setNewDate(date?.toISOString())
              }}
              onPanelChange={() => setNewDate('')}
            />
            <TimePicker.RangePicker
              onOpenChange={() => {
                setTimeSlot([])
              }}
              value={[timeSlot[0], timeSlot[1]]}
              onChange={value => {
                value && setTimeSlot([value[0], value[1]])

                value && console.log(value[0]?.toISOString())
                if (value !== null) {
                  setMultipleTimeSlots((prevSlots: any) => {
                    return [...prevSlots, [value[0]?.toISOString(), value[1]?.toISOString()]]
                  })
                }
              }}
            />
            <br></br>

            <Button
              disabled={(!existingDate || !newDate) && multipleTimeSlots.length === 0}
              type="primary"
              onClick={() => {
                if (selectedTestTrack.length > 0) {
                  if (!!existingDate) {
                    setNumOfSlots(prevData => {
                      const newData =
                        prevData &&
                        prevData.map(({ id, slots }) => {
                          if (id === selectedTestTrack) {
                            slots[existingDate].push(...multipleTimeSlots)
                          }
                          return { id, slots }
                        })

                      return newData
                    })
                  } else if (!!newDate) {
                    setNumOfSlots(prevData => {
                      let idNotFound = true
                      const newData =
                        prevData &&
                        prevData.map(({ id, slots }) => {
                          if (id === selectedTestTrack) {
                            idNotFound = false
                            slots[newDate] = []
                            slots[newDate].push(...multipleTimeSlots)
                          }
                          return { id, slots }
                        })
                      if (idNotFound) {
                        const newtestTrackData = { id: selectedTestTrack, slots: { [newDate]: [...multipleTimeSlots] } }
                        return prevData && [...prevData, newtestTrackData]
                      }

                      return newData
                    })
                  }
                }
                setNewDate('')
                setMultipleTimeSlots([])
                setDateVal(null)
              }}
            >
              Add Slot
            </Button>
          </Space>
          {multipleTimeSlots &&
            multipleTimeSlots.map((eachTimeSlot: any, idx: number) => (
              <div>
                <Space>
                  <Tag key={idx}>
                    <DateField value={eachTimeSlot[0]} format="LT" />
                    <span> to </span>
                    <DateField value={eachTimeSlot[1]} format="LT" />
                    <Icons.CloseOutlined
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        setMultipleTimeSlots((prevSlots: any) => {
                          prevSlots.splice(idx, 1)
                          return [...prevSlots]
                        })
                      }}
                    />
                  </Tag>
                </Space>
              </div>
            ))}
          <Divider />
          <>
            <Table dataSource={numOfSlots} bordered pagination={false} size="small">
              <Table.Column
                dataIndex="id"
                title="Test Track"
                render={(value, record) => {
                  const option = testTrackQueryOptions.filter(eachOption => eachOption.value === value)
                  const name = option[0]?.label
                  return (
                    <>
                      <Typography.Text>{name}</Typography.Text>
                    </>
                  )
                }}
              />
              <Table.Column
                title="Dates and Time Slots"
                // rowSpan={100}
                render={record => {
                  const dates = record?.slots && Object.keys(record.slots)
                  return renderDateTime(record, dates)
                }}
              />
            </Table>
          </> */}
          </Form.Item>
        </Col>
      </Form>
    </Modal>
  )
}
